"use strict";

exports.__esModule = true;
exports.encodeMethodIntoRequestBody = encodeMethodIntoRequestBody;
function encodeMethodIntoRequestBody(event) {
  if (event.target instanceof HTMLFormElement) {
    var form = event.target,
      fetchOptions = event.detail.fetchOptions;
    form.addEventListener("turbo:submit-start", function (_ref) {
      var submitter = _ref.detail.formSubmission.submitter;
      var body = isBodyInit(fetchOptions.body) ? fetchOptions.body : new URLSearchParams();
      var method = determineFetchMethod(submitter, body, form);
      if (!/get/i.test(method)) {
        if (/post/i.test(method)) {
          body.delete("_method");
        } else {
          body.set("_method", method);
        }
        fetchOptions.method = "post";
      }
    }, {
      once: true
    });
  }
}
function determineFetchMethod(submitter, body, form) {
  var formMethod = determineFormMethod(submitter);
  var overrideMethod = body.get("_method");
  var method = form.getAttribute("method") || "get";
  if (typeof formMethod == "string") {
    return formMethod;
  } else if (typeof overrideMethod == "string") {
    return overrideMethod;
  } else {
    return method;
  }
}
function determineFormMethod(submitter) {
  if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
    if (submitter.hasAttribute("formmethod")) {
      return submitter.formMethod;
    } else {
      return null;
    }
  } else {
    return null;
  }
}
function isBodyInit(body) {
  return body instanceof FormData || body instanceof URLSearchParams;
}